import {NgModule} from '@angular/core';
import {TrustboxComponent} from './trustbox.component';
@NgModule({
  declarations: [TrustboxComponent],
  imports: [],
  exports: [TrustboxComponent],
  providers: [TrustboxComponent]
})
export class TrustboxModule {}
